import React, { Ref, forwardRef, useImperativeHandle, useState } from 'react';
import { watchEvent } from 'src/js/events';
import { Dialog } from '@hai/ui-react';

interface WaitDialogProps {
  className?: string;
}

export interface WaitDialogRef {
  show?: () => void;
}

// To be used with Apply buttons
export const WaitDialog = forwardRef((props: WaitDialogProps, ref: Ref<WaitDialogRef>) => {
  const { className, ...rest } = props;
  const [shown, setShow] = useState(false);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  const show = () => {
    setShow(true);
  };

  watchEvent('show-wait-dialog', (content: { title: string; body: string }) => {
    setTitle(content.title);
    setBody(content.body);
    setShow(true);
  });

  watchEvent('close-wait-dialog', () => {
    setShow(false);
  });

  useImperativeHandle(ref, () => ({ show })); // hook internal show() to our forwarded props

  if (shown === false) {
    return undefined;
  }

  return (
    <Dialog
      {...rest}
      icon="none"
      className="mk-dialog-slim-bottom"
      headline={title}
      bodyText={
        <>
          {body}
          <div className="spacer p30" />
          <div className="hai-loader" style={{ zoom: 0.33, margin: '0 auto' }}>
            <svg id="hai-loader-outer-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <path d="M24,46c-12.15,0-22-9.85-22-22S11.85,2,24,2" vectorEffect="non-scaling-stroke" fill="none"></path>
            </svg>
            <div className="hai-loader-inner-wrapper">
              <svg id="hai-loader-inner-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                <path d="M46,24c0,12.15-9.85,22-22,22" vectorEffect="non-scaling-stroke" fill="none" />
                <path d="M2,24C2,11.85,11.85,2,24,2" vectorEffect="non-scaling-stroke" fill="none" />
              </svg>
            </div>
          </div>
          {/*
<IconCard text="loading-purple-sm">
  <Animation type="loading-purple-sm" />
</IconCard>*/}
        </>
      }
      onClose={() => {
        return;
      }}
      show={true}
      buttons={[]}
    />
  );
});

WaitDialog.displayName = 'WaitDialog';
